// extracted by mini-css-extract-plugin
export default {"requiredIndicator":"InputWrapper_requiredIndicator__uPKhU"};